import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-enviado-a-prefeitura',
  templateUrl: './projeto-enviado-a-prefeitura.component.html',
  styleUrls: ['./projeto-enviado-a-prefeitura.component.scss'],
})
export class ProjetoEnviadoPrefeituraComponent { }
